import { ReactNode } from "react";
import { RfxMailLayoutProps } from "../types/RfxMailLayoutProps.interface";

const data_get = (
	obj: any,
	key: string,
	defaultValue: string | null = null
) => {
	if (!obj) {
		return defaultValue;
	}
	const value =
		key.split(".").reduce((o, k) => (o || {})[k], obj) || defaultValue;
	return value;
};

interface ProcuraconMailLayoutProps {
	children: ReactNode;
	emailToName: string;
}


export const ProcuraconMailLayout: React.FC<ProcuraconMailLayoutProps> = ({
	emailToName,
	children,
}) => {
	return (
		<table
			width="100%"
			style={{ backgroundColor: "#ffffff" }}
		>
			<tr>
				<td align="center">
					<table
						width="600"
						style={{ maxWidth: "600px" }}
					>
						<tr>
							<td style={{ padding: "40px 0px" }}>
								<table
									cellPadding="0"
									cellSpacing="0"
									width="100%"
								>
									<tr>
										<td
											style={{
												fontFamily: "Arial, sans-serif",
												fontSize: "16px",
												lineHeight: "24px",
												color: "#1F2937",
												paddingBottom: "24px",
											}}
										>
											Hi{" "}
											{emailToName}
										</td>
									</tr>
									{children}
									<tr>
										<td
											style={{
												fontFamily: "Arial, sans-serif",
												fontSize: "16px",
												lineHeight: "24px",
												color: "#374151",
											}}
										>
											<br />
											Best Regards,
											<br />
											<br />
											<b>The Procuracon Team</b>
											<br />
											<i>Supporting transparent and efficient procurement</i>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</td>
			</tr>
		</table>
	);
};
